import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function Conversemos() {
  return <section className="w-full bg-ivory py-24 sm:py-32 lg:py-40" aria-labelledby="talk-title" data-id="element-29" data-mp="3u5xj4d0pgr5s">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-30" data-mp="bshohdwwfs5t">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-[1.15fr_0.85fr] lg:items-end lg:gap-24" data-id="element-31" data-mp="7r5ukw6zskrt">
          <Reveal data-id="element-32" data-mp="3g6ftxwjhzbvw">
            <h2 id="talk-title" className="font-sans text-[2rem] font-light uppercase leading-[1.08] text-ink sm:text-5xl xl:text-[3.4rem]" data-id="element-33" data-mp="3g80p9odmyyut">
              Conversemos.
            </h2>
            <p className="mt-6 font-serif text-2xl italic text-champagne sm:text-3xl" data-id="element-34" data-mp="3p5t30o3plyg3">
              Todo comienza con una conversación.
            </p>
            <p className="mt-8 max-w-xl font-sans text-[17px] font-light leading-relaxed text-steel sm:text-lg" data-id="element-35" data-mp="14gvm3sk2smgu">
              Conoce la oportunidad, haz tus preguntas y descubre si este camino
              puede conectar con tus metas.
            </p>
          </Reveal>

          <Reveal delay={0.08} data-id="element-36" data-mp="1giisdb3vko6">
            <div className="border-t border-ink/15 pt-8 lg:border-l lg:border-t-0 lg:pl-10 lg:pt-0" data-id="element-37" data-mp="1fr0232lxhfb">
              <p className="font-sans text-[10px] font-medium uppercase tracking-widest2 text-champagne sm:text-[11px]" data-id="element-38" data-mp="6gwty4807aqf">
                Encuentro presencial
              </p>
              <p className="mt-5 font-sans text-xl font-medium uppercase tracking-[0.16em] text-ink sm:text-2xl" data-id="element-39" data-mp="39x3uw2z1atvi">
                Miami, FL 33172
              </p>
              <p className="mt-6 max-w-sm font-sans text-base font-light leading-relaxed text-steel" data-id="element-40" data-mp="3etlu6nbli00g">
                Coordinaremos contigo el día y horario. Si no estás cerca de
                esta zona, podemos acordar un punto de encuentro que funcione
                para ambas partes.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.12} data-id="element-41" data-mp="2w45m9exkz5a0">
          <div className="mt-16 border-t border-ink/15 pt-12 sm:mt-20" data-id="element-42" data-mp="2w347azdg1yn0">
            <CtaButton label="Agendar una conversación" tone="ink" className="w-full sm:w-auto" data-id="element-43" data-mp="2o36ko66a9ek1" />
          </div>
        </Reveal>
      </div>
    </section>;
}